//  CallFormView component, api end point accesing from apiConfig - 23-08-24 - Dev Srini

import { useState, useContext, useEffect } from 'react'

import TableDisplay from './TableContent/TableDisplay'
import CallInterface from './CallInterface'
import CallFormView from './CallLogs/CallFormView'

import { reducerContext } from '../../../../contextApi\'s/contextApi\'s'
import { httpRequest } from '../../../../ui-utils/api'
import { apiUrl } from '../../../../ui-utils/apiConfig'

const Dashboard = () => {

    const { state, dispatch } = useContext(reducerContext)
    const { refreshToken, callHistoryChat, customerPendingTasks, callLogs, playBackAudio } = state

    const [tabId, setTabId] = useState(0)
    const [callFormToggle, setCallFormToggle] = useState(false)
    const [callForm, setCallForm] = useState({})

    useEffect(() => {
        if (refreshToken) {
            (async () => {
                try {
                    const pendingTasks = await httpRequest({
                        endPoint: `${apiUrl.agentId}/${localStorage.getItem('user_id1')}`,
                        method: "get",
                        instance: "instanceOne",
                    })

                    if (pendingTasks.success) {
                        const pendingTasksResult = pendingTasks.data.msg.filter(item => item.status !== 'Closed')
                        dispatch({
                            type: 'SET_CUSTOMER_PENDING_TASKS',
                            payload: pendingTasksResult
                        })
                    }
                    // Dev Srini 25/10/24
                    else {
                        console.log('Error in AgentId/PendingTask API', pendingTasks)
                    }

                }
                catch (error) {
                    console.log('Error in AgentId/PendingTask API', error)
                }
            })()
        }
    }, [refreshToken])

    const handleTabChange = (event, newValue) => {
        setTabId(newValue)
    }

    const handleCallForm = (obj) => {
        setCallFormToggle(!callFormToggle)
        setCallForm(obj)
    }

    
    return (
        <div style={{ width: '84%', marginLeft: '2%', }}>
            <TableDisplay
                callHistoryChat={callHistoryChat}
                tabId={tabId}
                dispatch={dispatch}
                customerPendingTasks={customerPendingTasks}
                callLogs={callLogs}
                handleTabChange={handleTabChange}
                playBackAudio={playBackAudio}
                handleCallForm={handleCallForm}
            />

            <div style={{ position: 'absolute', top: 65, right: 100 }}>
                <CallInterface
                    dispatch={dispatch}
                />
            </div>

            <CallFormView
                callFormToggle={callFormToggle}
                callForm={callForm}
                handleCallForm={handleCallForm}
            />

        </div>
    )
}

export default Dashboard